function toggleShippingEstimator() {
  var body = document.getElementById('shipping-estimator-body');
  var arrow = document.getElementById('shipping-estimator-arrow');
  if (body.style.display === 'none') {
    body.style.display = 'block';
    arrow.textContent = '▲';
  } else {
    body.style.display = 'none';
    arrow.textContent = '▼';
  }
}

function estimateShippingDrawer(e) {
  if (e) e.preventDefault();
  var zip = document.getElementById('shipping-zip-drawer').value.trim();
  var province = document.getElementById('shipping-province-drawer').value.trim();
  var country = document.getElementById('shipping-country-drawer').value;
  var resultsDiv = document.getElementById('shipping-results-drawer');

  if (!zip || !province) {
    resultsDiv.innerHTML = '<p>Please enter a postal code and province/state.</p>';
    return;
  }

  resultsDiv.innerHTML = '<p>Calculating...</p>';

  fetch('/cart/shipping_rates.json'
    + '?shipping_address[zip]=' + encodeURIComponent(zip)
    + '&shipping_address[province]=' + encodeURIComponent(province)
    + '&shipping_address[country]=' + encodeURIComponent(country))
    .then(function(r){ return r.json(); })
    .then(function(data){
      if (data.shipping_rates && data.shipping_rates.length > 0) {
        var html = '<ul style="list-style:none;padding:0;margin:0;">';
        data.shipping_rates.forEach(function(rate){
          var price = parseFloat(rate.price) === 0
            ? '<strong>FREE</strong>'
            : rate.currency + ' $' + parseFloat(rate.price).toFixed(2);
          html += '<li style="padding:0.25rem 0; border-bottom:1px solid #eee;">'
            + rate.name + ': ' + price + '</li>';
        });
        html += '</ul>';
        resultsDiv.innerHTML = html;
      } else {
        resultsDiv.innerHTML = '<p>No rates found for this location.</p>';
      }
    })
    .catch(function(){
      resultsDiv.innerHTML = '<p>Unable to calculate. Please try again.</p>';
    });
}
